/**
 * Copyright 2023-2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button } from "@nordcloud/gnui";
import { StyledLink } from "~/components";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { PlansTable } from "~/views/plans/PlansTable/PlansTable";

const breadcrumbsLabels = [
  { label: "Dashboard", uri: "/" },
  { label: "Plans", uri: ROUTES.plans.index },
];

export function PlansPage() {
  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox title="Plans" customBreadcrumbs={breadcrumbsLabels}>
            <StyledLink to={ROUTES.plans.create}>
              <Button icon="plus">Create Plan</Button>
            </StyledLink>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <PlansTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
